import axios, { AxiosError, AxiosHeaders, AxiosRequestConfig } from "axios";

const CarbonClient = axios.create({
  baseURL: import.meta.env.VITE_CARBON0_BASEURL,
  timeout: 0,
});

CarbonClient.interceptors.request.use((request) => {
  return new Promise(function (resolve /*, reject*/) {
    const token = localStorage.getItem("carbon0.accessToken");
    if (token && request.headers) {
      request.headers = new AxiosHeaders({
        Accept: "application/json",
        "Content-Type": request.headers["Content-Type"] ?? "application/json",
        Authorization: `Bearer ${token}`,
      });
    }
    resolve(request);
  });
});

CarbonClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // handleAuthError();
    }
    // Request was aborted (e.g. navigation/page reload) — not a real error, drop silently
    if (axios.isAxiosError(error) && error.code === AxiosError.ECONNABORTED && !error.response) {
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

// `config` is forwarded to axios untouched — it exists so callers can pass `params` (axios
// drops the undefined ones) instead of hand-building a query string.
const get = async <T>(url: string, config?: AxiosRequestConfig) => {
  try {
    const response = await CarbonClient.get(url, config);
    return response.data as T;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.error("Error response:", error.response.data);
        console.error("Error status:", error.response.status);
        console.error("Error headers:", error.response.headers);
      } else if (error.request) {
        console.error("Error request:", error.request);
      } else {
        console.error("Error message:", error.message);
      }
      console.error("Error config:", error.config);
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};

const post = async (url: string, data: any) => {
  try {
    const response = await CarbonClient.post(url, data);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.error("Error response:", error.response.data);
        console.error("Error status:", error.response.status);
        console.error("Error headers:", error.response.headers);

        // Return the error response data along with an error indicator
        return {
          error: true,
          status: error.response.status,
          data: error.response.data,
        };
      } else if (error.request) {
        console.error("Error request:", error.request);
      } else {
        console.error("Error message:", error.message);
      }
      console.error("Error config:", error.config);
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};

export default CarbonClient;

export { get, post };
